module.exports = __webpack_public_path__ + "media/images/plumber-bg-1-27fdb6861dc8e05431d41338d1afafa8.jpg";